import { BasePlugin, LayoutBasePlugin, registerEditorPlugin } from 'amis-editor-core';
import { __extends, __assign } from 'tslib';
import { labelKeys } from '@/utils/designUtils'
import i18n from '@/i18n/i18n';

const ENKEY = "data.enUS";
const CNKEY = "data.zhCN";

const fetchComponentLable = (component) => {
  if (!component) {
    return null
  }
  let result = []
  if (component instanceof Array) {
    component.forEach(c => {
      const list = fetchComponentLable(c)
      if (list) {
        result = result.concat(list)
      }
    })
    return result
  }
  if (!(component instanceof Object)) {
    return null
  }
  const keys = Object.keys(component)
  keys.forEach(k => {
    let v = component[k]
    if ((v instanceof Array) || (v instanceof Object)) {
      const list = fetchComponentLable(v)
      if (list) {
        result = result.concat(list)
      }
      return
    }
    if (labelKeys.indexOf(k) >= 0) {
      if (!v || typeof(v) !== 'string') {
        return
      }
      result.push(v)
    }
  })
  return result
}

var LanguageConfigurePlugin = /** @class */function (_super) {
  __extends(LanguageConfigurePlugin, _super);
  function LanguageConfigurePlugin() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // 关联渲染器名字
    _this.rendererName = 'language-configure';
    _this.$schema = '/schemas/UnkownSchema.json';
    // 组件名称
    _this.name = i18n.t('多语言');
    _this.isBaseComponent = true;
    _this.icon = 'fa fa-file-code-o';
    _this.pluginIcon = 'fa fa-file-code-o';
    _this.description = i18n.t('多语言配置，当页面需要支持多语言切换时，可使用此组件类配置静态多语言数据');
    _this.tags = [i18n.t('扩展组件')];
    _this.scaffold = {
      type: 'language-configure',
      label: i18n.t('多语言'),
      name: 'language-configure',
      body: [ // 容器类字段
        {
          "type": "tpl",
          "tpl": "",
          "inline": false
        }
      ]
    };
    _this.previewSchema = {
      type: 'language-configure',
      label: i18n.t('多语言'),
    }
    // 容器类组件必需字段
    _this.regions = [{
      key: 'body',
      label: i18n.t('内容区')
    }];
    _this.panelTitle = i18n.t('多语言配置');
    _this.panelJustify = true;
    _this.panelControls = [
      {
        "type": "flex",
        "justify": "space-between",
        "alignItems": "center",
        "items": [
          {
            "type": "tpl",
            "tpl": i18n.t('子组件文案')
          },
          {
            "type": "flex",
            "justify": "space-between",
            "alignItems": "center",
            "items": [
              {
                "style": {
                  "margin-right": "10px"
                },
                "type": "button",
                "size": "xs",
                "level": "danger",
                "label": i18n.t('清空语言设置'),
                "onClick": (event, props) => {
                  props.formStore.setValueByName(CNKEY, {})
                  props.formStore.setValueByName(ENKEY, {})
                }
              },
              {
                "type": "button",
                "size": "xs",
                "level": "primary",
                "label": i18n.t('遍历收集'),
                "onClick": (event, props) => {
                  const body = props.data?.body
                  const data = props.data?.data ?? {}
                  const zhCN = { ...data.zhCN }
                  const enUS = { ...data.enUS }
                  const labels = fetchComponentLable(body)
                  labels && labels.forEach(l => {
                    zhCN[l] = zhCN[l] || l
                    enUS[l] = enUS[l] || l
                  })
                  props.formStore.setValueByName(CNKEY, zhCN)
                  props.formStore.setValueByName(ENKEY, enUS)
                }
              }
            ]
          }
        ]
      },
      {
        "type": "divider",
        "title": i18n.t('中英文'),
      },
      {
        "type": "input-kv",
        "name": CNKEY,
        "label": i18n.t('中文'),
        "visible": false,
        "draggable": false
      },
      {
        "type": "input-kv",
        "name": ENKEY,
        "labelClassName": "invisible",
        "draggable": false,
        "onChange": (value, old, model, page) => {
          const zhCN = {}
          const keys = Object.keys(value)
          keys.forEach(k => {
            zhCN[k] = k
          })
          page.setValueByName(CNKEY, zhCN)
        }
      }
    ];
    return _this;
  }
  LanguageConfigurePlugin.id = 'LanguageConfigurePlugin';
  LanguageConfigurePlugin.scene = ['layout'];
  return LanguageConfigurePlugin;
}(LayoutBasePlugin);
registerEditorPlugin(LanguageConfigurePlugin);

export { LanguageConfigurePlugin };